import React from "react";
import useProductParams from "../../../../hooks/useProductParams";
import { getProductData } from "../../../../services/productService";
import { useQuery } from "@tanstack/react-query";
import { fetchResource, queryKeys } from "../../../../services/reactQuery/reactQueryService";
import LegalbirdLoader from "../../../../components/ContentLoader/LegalbirdLoader";
import UploadFineNotice from "./UploadFineNotice";
import LayoutAuthenticated from "@/src/containers/Layouts/LayoutAuthenticated";

export default function UploadFineNoticePage() {
  const { productId } = useProductParams();
  const productApiUri = getProductData("traffic", "apiUri");
  const { data: traffic, isLoading } = useQuery({
    queryKey: queryKeys.item(productApiUri, productId),
    queryFn: () => fetchResource(productApiUri, productId),
  });

  if (isLoading) {
    return (
      <LayoutAuthenticated>
        <LegalbirdLoader />
      </LayoutAuthenticated>
    );
  }

  return (
    <LayoutAuthenticated>
      <UploadFineNotice traffic={traffic} />
    </LayoutAuthenticated>
  );
}
